

































































































import Vue from "vue";
import ApiService from "../../services/ApiService";
import { yearToNameFull } from "@/services/GeneralHelper";
import SingleStudent from "@/modals/SingleStudent.vue";
export default Vue.extend({
  data() {
    return {
      data: [],
      loading: true,
      parent: "",
      name: "",
      year: "",
      email: "",
      // yearToName: {
      //   "-1": "Nursery",
      //   0: "Reception",
      //   1: "Year 1",
      //   2: "Year 2",
      //   3: "Year 3",
      //   4: "Year 4",
      //   5: "Year 5",
      //   6: "Year 6",
      //   7: "Year 7",
      //   8: "Year 8",
      //   9: "Year 9",
      //   10: "Year 10",
      //   11: "Year 11",
      //   12: "Year 12",
      //   13: "Year 13"
      // }
    };
  },
  methods: {
    handleClick() {
      alert("handle");
    },
    getPupils() {
      ApiService.generalApi.getSchoolUsers().then((resp) => {
        const data = resp.data;
        data.forEach((element) => {
          element.name = element.first_name + " " + element.last_name;
          element.name = element.first_name + " " + element.last_name;
          element.year = yearToNameFull(element.current_year);
        });
        this.loading = false;
        this.data = data;
      });
    },
    openStudent(studentId) {
      this.$modal.show(
        SingleStudent,
        {
          options: {
            profilePicture: true,
          },
          studentId,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          height: 500,
          adaptive: true,
          width: 700,
          // pivotY: 0
        },
        {
          "before-close": this.beforeClose,
        }
      );
    },
    beforeClose() {
      this.getPupils();
    },
  },
  mounted() {
    this.getPupils();
  },
});
